import { render, staticRenderFns } from "./SpecializationItem.vue?vue&type=template&id=079644e7&scoped=true&"
import script from "./SpecializationItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SpecializationItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SpecializationItem.vue?vue&type=style&index=0&id=079644e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079644e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079644e7')) {
      api.createRecord('079644e7', component.options)
    } else {
      api.reload('079644e7', component.options)
    }
    module.hot.accept("./SpecializationItem.vue?vue&type=template&id=079644e7&scoped=true&", function () {
      api.rerender('079644e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuSpecializations/components/SpecializationItem.vue"
export default component.exports